import { render, staticRenderFns } from "./TeacherMiniCardUI.vue?vue&type=template&id=55e31a90&lang=pug&"
import script from "./TeacherMiniCardUI.vue?vue&type=script&lang=js&"
export * from "./TeacherMiniCardUI.vue?vue&type=script&lang=js&"
import style0 from "./TeacherMiniCardUI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports